import React from 'react';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import { useAppState } from '../../../components/app-context/src';
import ROUTES from '../../../config/routes';

const TosRoutes = (props) => {
  const { path } = useRouteMatch();
  const appState = useAppState();

  return (
    <Switch>
      <Redirect
        exact
        from={`${path}/${ROUTES.ABOUT_TOS}`}
        to={`${path}/${ROUTES.ABOUT_TOS}/${appState.fallbackLocale}`}
      />

      <Route
        path={`${path}/${ROUTES.ABOUT_TOS}`}
        component={React.lazy(() =>
          import(`../../../packages/about/terms-of-service`)
        )}
      />
    </Switch>
  );
};

export default TosRoutes;
